export default "__VITE_ASSET__CImccOpd__"